/**
 * Layout constants, ported from the spec's `renderVals()`. Everything here is a
 * pinned number from the design — components read these rather than inventing
 * their own spacing.
 */

export const TOKENS = {
  /** Section header — 13px, uppercase, 0.02em, weight 600, padding 18/28/6. */
  sectionHeader: {
    fontSize: 13,
    letterSpacing: '0.02em',
    fontWeight: 600,
    padding: '18px 28px 6px',
  },
  /** Group card — radius 10 (iOS) / 12 (Material), margin 0 12px. */
  card: {
    radiusIos: 10,
    radiusMaterial: 12,
    marginX: 12,
  },
  /** List row (overview) — min-height 60 mobile / 52 desktop, padding 0 16px. */
  listRow: {
    minHeightMobile: 60,
    minHeightDesktop: 52,
    paddingX: 16,
  },
  /** Item row (detail) — min-height 56 mobile / 46 desktop, gap 12. */
  itemRow: {
    minHeightMobile: 56,
    minHeightDesktop: 46,
    gap: 12,
    paddingX: 16,
  },
  /** Checkbox — 24x24 circle, 2px border, fills --tg-button when done. */
  checkbox: { size: 24, borderWidth: 2 },
  /** Category chip — 12px/600, radius 8, padding 3px 8px. */
  chip: { fontSize: 12, fontWeight: 600, radius: 8, padding: '3px 8px' },
  /** Desktop shell — 60px header, 280px sidebar, 720px content column. */
  desktop: { headerHeight: 60, sidebarWidth: 280, contentMaxWidth: 720 },
  /** Add-item bar — 40px pill (radius 20) + 40px circular send button. */
  addBar: { height: 40, pillRadius: 20, buttonSize: 40 },
  /** FAB — 56px, radius 28 (iOS) / 18 (Android). Web mobile only. */
  fab: { size: 56, radiusIos: 28, radiusMaterial: 18, right: 16, bottom: 20 },
  /** MainButton — 50px, radius 10, full width. Telegram only. */
  mainButton: { height: 50, radius: 10 },
  /** Toast — centered, bottom 78px, radius 12, auto-dismiss 2600ms. */
  toast: { bottom: 78, radius: 12, timeoutMs: 2600 },
  /** Dialog — bottom sheet, 24px top radius; 360px card radius 16 on desktop. */
  dialog: { sheetRadius: 24, cardWidth: 360, cardRadius: 16 },
  /** Bottom nav shell. One tab today; the row is sized for more. */
  bottomNav: { height: 52 },
} as const;

/** Safe bottom inset — iPhone 30 / Android 14 / web-mobile 20 / desktop 8. */
export const SAFE_BOTTOM = {
  'telegram-ios': 30,
  'telegram-android': 14,
  'web-mobile': 20,
  'web-desktop': 8,
} as const;

/** Telegram header — safe area + the 44px nav bar. */
export const TELEGRAM_HEADER_HEIGHT = {
  ios: 103,
  android: 68,
} as const;

/** Below this viewport width the web surface renders its mobile layout. */
export const DESKTOP_BREAKPOINT = 900;
